export default {
  api: {
    host: 'https://api.reviews.nzdigital.co.nz',
    // host: 'http://localhost:8080',
    path: '/graphql'
  }
}


// WEBPACK FOOTER //
// ./src/config.js